<script lang="ts">
  import { Accordion as AccordionPrimitive } from 'bits-ui-v2'
  import { cn } from '$lib/cn'

  let {
    ref = $bindable(null),
    value = $bindable(),
    class: className,
    ...restProps
  }: AccordionPrimitive.RootProps = $props()
</script>

<AccordionPrimitive.Root
  bind:ref
  bind:value={value as never}
  data-slot="accordion"
  class={cn('flex w-full flex-col', className)}
  {...restProps}
/>
